<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
  data() {
        return {
            nomeEmpresa: ''
        };
  },
  watch: {
    $route(to) {
       this.applyBackgroundClass(to);
    }
  },
  mounted() {
    this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
    this.applyBackgroundClass(this.$route);
  },
  methods:{
     applyBackgroundClass(route) {
      document.body.classList.remove('root-background-genial');
      document.body.classList.remove('root-background-actual');
      document.body.classList.remove('root-background-rji');
      document.body.classList.remove('root-background');
      document.body.classList.remove('root-background-rji-cadastro');
      document.body.classList.remove('root-background-actual-cadastro');

      const path = route.path.toUpperCase();

      if (path === '/LOGIN' && this.nomeEmpresa === 'GENIAL') {
        document.body.classList.add('root-background-genial');
      } else if (path === '/LOGIN' && this.nomeEmpresa === 'ACTUAL') {
        document.body.classList.add('root-background-actual');
      } else if (path === '/LOGIN' && this.nomeEmpresa === 'RJI') {
        document.body.classList.add('root-background-rji');
      } else if (
        (path === '/CADASTROPF_PASSO_1' || 
         path === '/CADASTROPJ_PASSO_1' || 
         path === '/CADASTROFI_PASSO_1') && this.nomeEmpresa === 'RJI'
      ) {
        document.body.classList.add('root-background-rji-cadastro');
      } else if (
        (path === '/CADASTROPF_PASSO_1' || 
         path === '/CADASTROPJ_PASSO_1' || 
         path === '/CADASTROFI_PASSO_1') && this.nomeEmpresa === 'ACTUAL'
      ) {
        document.body.classList.add('root-background-actual-cadastro');
      }
    }
  }
}
</script>

<style>
body, html {
  height: 100%;
  margin: 0;
}

.root-background-genial {
  background: linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url('@/assets/fundoGenial.png') !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;
}

.loading-overlay {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  border-top-color: #3b8070;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}


.root-background-actual {
  background: url('@/assets/fundo_actual.png') !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;
}

.root-background-rji {
  background: linear-gradient(rgba(15, 37, 71, 0.5), rgba(15, 37, 71, 0.5)), url('@/assets/fundoRJI.png') !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;
}

.root-background-actual-cadastro {
  background-color: rgba(15, 37, 71, 1) !important;
}

  .root-background-actual-cadastro .site-header{
    
      margin-bottom: 10px;
  }

.root-background-rji-cadastro{
  background-color: rgba(15, 37, 71, 1) !important;
}

  .root-background-rji-cadastro .site-header{
      background-color: rgba(15, 37, 71, 1) !important;
  }

</style>
